import {AndroidDeviceDependencies} from '../types';
import {androidBridge} from '../messageBridge';

export function sendMessage(message: Message, di: AndroidDeviceDependencies = {}): void {
  if (!message) return;

  const {bridge = androidBridge} = di;
  bridge.sendMessage?.(message);
}
